import { useState } from "react";
import Link from "next/link";

import { Menu } from "~/assets";
import { Button, Popover, PopoverClose, PopoverContent, PopoverTrigger } from "~/components/ui";
import { useSwapKit } from "~/context/swapkit";

export function NavbarMobilePopover() {
  const [isOpen, setIsOpen] = useState(false);
  const { isConnected } = useSwapKit();

  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger>
        <Menu className="h-6 w-6" />
      </PopoverTrigger>

      <PopoverContent
        sideOffset={26}
        className="h-[var(--radix-popover-content-available-height)] w-[var(--radix-popover-content-available-width)]"
      >
        <PopoverClose />

        <div className="mt-6 flex flex-col items-center space-y-6">
          <Link href="/market" onClick={() => setIsOpen(false)}>
            <div className="text-[#F7FAFD]">Market</div>
          </Link>

          <Link href="/register" onClick={() => setIsOpen(false)}>
            <div className="text-[#F7FAFD]">Register</div>
          </Link>

          {isConnected && (
            <Button size="sm" asChild className="w-full" onClick={() => setIsOpen(false)}>
              <Link href="/profile">My Profile</Link>
            </Button>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}
